import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomAlertButton } from 'src/app/shared/services/alert-modal.service';
import ValueGuard from 'src/app/shared/utils/value-guard';

@Component({
  selector: 'app-alert-modal-v2',
  templateUrl: './alert-modal-v2.component.html',
  styleUrls: ['./alert-modal-v2.component.scss'],
})
export class AlertModalV2Component implements OnInit {
  public modalRef: NgbModalRef;
  public buttons: CustomAlertButton[] = [];
  public header: string;
  public message: string;

  public isAsyncProcessLoading = false;

  constructor() {}

  public handleButton(btn: CustomAlertButton) {
    btn.handler();
    this.modalRef.dismiss();
  }

  public async handleAsyncButton(btn: CustomAlertButton, event?: any) {
    this.isAsyncProcessLoading = true;
    try {
      await btn.handler();
      this.modalRef.dismiss();
      this.isAsyncProcessLoading = false;
      event.complete();
    } catch (err) {
      console.error(err);

      this.modalRef.dismiss();
      this.isAsyncProcessLoading = false;
      event.complete();
      throw err;
    }
  }

  public getBtnClass(btn: CustomAlertButton) {
    if (ValueGuard.againtsNullOrUndefined(btn.customClass)) {
      return `btn ${btn.customClass}`;
    }

    switch (btn.class) {
      case 'danger':
        return 'btn btn-danger';
      case 'info':
        return 'btn btn-info';
      case 'warning':
        return 'btn btn-warning';
      case 'light':
        return 'btn btn-light';
      default:
        return 'btn btn-primary';
    }
  }

  ngOnInit(): void {}
}
